import { render, staticRenderFns } from "./User-retreat-chart.vue?vue&type=template&id=50d7889a&scoped=true&"
import script from "./User-retreat-chart.vue?vue&type=script&lang=js&"
export * from "./User-retreat-chart.vue?vue&type=script&lang=js&"
import style0 from "./User-retreat-chart.vue?vue&type=style&index=0&id=50d7889a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7889a",
  null
  
)

export default component.exports